import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {AuditModule} from "./audit/audit.module";
import {PickupPointFeeModule} from "./pickuppointfee/pickup-point-fee.module";
import {CoreModule} from "../core/core.module";
import {ContactModule} from "./contact/contact.module";
import {Sample2Module} from "./sample-v2/sample.module";
import {InternalErrorModule} from "./internal-error/internal-error.module";
import {HomeModule} from "./home/home.module";
import {InsuranceModule} from "./insurance/insurance.module";
import {AdditionalModule} from "./additional/additional.module";
import {LogoutModule} from "./logout/logout.module";
import {BookingModule} from "./booking/booking.module";
import {RestrictionsModule} from "./restrictions/restrictions.module";
import {PointOfSaleModule} from "./pointOfSale/point-of-sale.module";
import {AdditionalPointModule} from "./additionalPoint/additional-point.module";
import {AgeRangeModule} from "./ageRange/age-range.module";
import {CarTemplateModule} from "./carTemplate/car-template.module";

@NgModule({
    imports: [CommonModule, FormsModule,AuditModule, TranslateModule, PickupPointFeeModule,
        CoreModule ,ContactModule,Sample2Module, InternalErrorModule, HomeModule, RestrictionsModule, BookingModule,
        LogoutModule, AdditionalModule, InsuranceModule, PointOfSaleModule,AdditionalPointModule, AgeRangeModule, CarTemplateModule],
    declarations: []
})
export class FeatureModule {}



// WEBPACK FOOTER //
// ./public/upgrade/feature/feature.module.ts